<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Member Transaction History</h4>
                    </div>
                    <div class="card-body">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col-md-3">
                                    <div>
                                        <button type="button" @click="goBack"
                                            class="btn mr-1 btn-info text-white btn-secondary btn-sm"> Back </button>

                                        <input class="form-control" v-model="serverParams.customFilters.name"
                                            type="text" name="search" id="search" placeholder="Search"
                                            @keyup="onSearch" />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <h4 class="card-title"> {{ rows.length > 0 ? rows[0].FirstName + rows[0].lastName :
                                        '' }}</h4>
                                </div>
                                <div class="col-md-3" style="font-size:13px; font-weight:300;">
                                    <h4 class="card-title">
                                        UserID: {{ rows.length > 0 ? rows[0].UserID : '' }} </h4>
                                </div>

                            </div>
                        </div>
                        <vue-good-table mode="remote" @on-sort-change="onSortChange" @on-page-change="onPageChange"
                            @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :isLoading.sync="isLoading"
                            :pagination-options="{ enabled: true, dropdownAllowAll: false, perPageDropdown: [10, 20, 50, 100, 200], }"
                            :rows="rows" :columns="columns" :sort-options="{
                                enabled: false,
                            }">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'action'" class="text-nowrap"> </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import SortedTablePlugin from "vue-sorted-table";
import _debounce from 'lodash/debounce';
import API from '@/api'
import moment from 'moment'

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Users',
    data() {
        return {
            isDisabled: false,
            selected: true,
            debouncedSearch: _debounce(this.loadItems, 300),
            unSelected: false,
            serverParams: {
                customFilters: {
                    name: ''
                },
                sort: [
                    {
                        field: 'PaymentDate',
                        type: 'desc'
                    }
                ],
                UserID: this.$route.params.id,
                page: 1,
                perPage: 10
            },
            columns: [
                {
                    label: 'Date',
                    field: 'PaymentDate',
                    filterable: false,
                    sortable: true,
                    formatFn: this.formatDate,
                },
                {
                    label: 'Transaction',
                    field: 'ServiceName',
                    sortable: true,

                },
                {
                    label: 'Pmt',
                    field: "TotalPayment",
                    sortable: true,
                    formatFn: this.dollarFn,
                },
                {
                    label: 'Pmt Status',
                    field: "Status",
                    sortable: true,
                },
                {
                    label: 'Refund',
                    field: "refund",
                    sortable: true,
                    // type: 'percentage',

                },
                {
                    label: 'Balance',
                    field: "TotalPayment - ",
                    sortable: true,
                    // formatFn: this.dollarFn,

                },
                {
                    label: 'Failure Message',
                    field: "PayFailureMessage",
                    sortable: true,
                    // type: 'percentage',

                },
                {
                    label: 'Attempts',
                    field: "Attempts",
                    sortable: true,
                },
                {
                    label: 'User Status',
                    field: "MemberStatus",
                    sortable: true,
                },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            // readonly: true,
            // UserID: JSON.parse(localStorage.getItem('userDetails')).userID,
            // UserID: 10,
        };
    },
    methods: {
        loadItems() {
            this.isLoading = true;
            API.getAllBillingDetails(this.serverParams, this.$route.params.id,
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data.data.map(item => {
                        // Check if "Attempts" is 0 and update it to 1
                        if (item.Attempts == 0) {
                            item.Attempts = 1;
                        }
                        return item;
                    });
                    this.isLoading = false;
                }, err => {
                    this.isLoading = false;
                })
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('MMM DD, yyyy')
            }
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        goBack() {
            this.$router.push({ name: 'Billing' });
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        onSearch() {
            this.debouncedSearch(); // Use debounced search function
        },
        dollarFn: function (value) {
            if (!isNaN(value) && value !== null) {
                return '$' + parseFloat(value).toFixed(2);
            } else {
                return '$0.00';
            }
        },
        onSortChange(params) {
            this.updateParams({
                sort: [{
                    type: params[0].type,
                    field: params[0].field,
                }],
            });
            this.loadItems();
        },
        onColumnFilter(params) {
            this.updateParams(params);
            this.loadItems();
        },

    },
    computed: {}
    ,
    mounted() {
        this.loadItems();
        // this.serverParams.UserID = this.$route.params.id;
        // this.loginUser = JSON.parse(localStorage.getItem('userDetails'));
        // this.UserID = this.loginUser.userID;
    },
}
</script>
